/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2022-08-24 16:57:01
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionList/config.tsx
 */
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
// import Link from 'src/components/Link/Link';
import { replaceI18nVariables } from '@/src/tools/tools';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { handleOnFormatStoreTimeAndDateWithTimezone } from '@/src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';

export {
  breadcrumbData,
  columns,
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
};

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.sider.analytics'),
  },
  {
    url: '',
    name: getI18n('general.sider.reportSubscription'),
  },
];

const columns = (
  timezoneInGMT,
  onDelete,
  onEdit,
  disableEdit,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n(
      'reportSubscription.reportSubscriptionList.config.subname_title',
    ),
    dataIndex: 'name',
    key: 'name',
    default: true,
    sorter: true,
    className: css.columnClass,
    width: 272,
  },
  {
    title: getI18n(
      'reportSubscription.reportSubscriptionList.config.sendon_name',
    ),
    dataIndex: 'sendTime',
    default: true,
    key: 'sendTime',
    className: css.columnClass,
    minWidth: 200,
    childGenerate: (text) => (
      <NoWrapContainer>
        <Tooltip title={text.unit}>{text.unit}</Tooltip>
      </NoWrapContainer>
    ),
  },
  {
    title: replaceI18nVariables(
      getI18n(`reportSubscription.reportSubscriptionList.config.last_name`),
      timezoneInGMT,
    ),
    dataIndex: 'lastSent',
    default: true,
    key: 'lastSent',
    className: css.columnClass,
    minWidth: 200,
    sorter: true,
    childGenerate: (text) => {
      const time = text ? handleOnFormatStoreTimeAndDateWithTimezone(text) : '';
      return (
        <NoWrapContainer>
          <Tooltip title={time}>{time}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: replaceI18nVariables(
      getI18n(`reportSubscription.reportSubscriptionList.config.next_name`),
      timezoneInGMT,
    ),
    dataIndex: 'nextSend',
    default: true,
    key: 'nextSend',
    className: css.columnClass,
    minWidth: 200,
    sorter: true,
    childGenerate: (text) => {
      const time = text ? handleOnFormatStoreTimeAndDateWithTimezone(text) : '';
      return (
        <NoWrapContainer>
          <Tooltip title={time}>{time}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    key: 'actions',
    className: css.columnClass,
    align: 'center',
    position: EnumTablePosition.mid,
    minWidth: 168,
    childGenerate: (url, record, index) => {
      return (
        <Actions
          onDelete={() => onDelete([record.uuid])}
          onEdit={() => onEdit(record.uuid)}
          disableDelete={disableDelete}
          disableEdit={disableEdit}
        />
      );
    },
  },
];
